import React, { useState } from "react";
import { Avatar, Chip, IconButton, TableCell, TableCellProps, TableRow } from "@mui/material";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import { OmittedMeasureTableDataRow } from "store/types";
import { useFormatDateHook } from "hooks";
import { currencySign } from "../../../../constants";

const commonCellStyles: TableCellProps["sx"] = {
  borderBottom: "0.5px solid #dae0e2",
  fontSize: "15px",
  color: "#013951",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  maxWidth: "250px",
  backgroundColor: "transparent",
  height: "50px"
};

interface RowProps {
  row: OmittedMeasureTableDataRow;
  borderLess?: boolean;
  hideChildCell?: boolean;
}

export const Row: React.FC<RowProps> = ({ row }) => {
  const formatDate = useFormatDateHook();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const formatValue = (item: OmittedMeasureTableDataRow) => {
    const numerified = Number(item.value)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const postfix = item.currency ? currencySign[item.currency!] : item.postfix || "";
    const result = item.postfix === "%" ? `${numerified}%` : `${postfix}${numerified}`;
    return result;
  };

  return (
    <>
      <TableRow>
        <TableCell sx={commonCellStyles}>
          {!!row.children?.length && (
            <IconButton
              sx={{ transform: isOpen ? "rotate(90deg)" : "rotate(0deg)" }}
              onClick={() => setIsOpen(!isOpen)}
              size="sm"
            >
              <ArrowForwardIosOutlinedIcon sx={{ fontSize: "16px", color: "#0a3142" }} />
            </IconButton>
          )}
        </TableCell>
        <TableCell sx={commonCellStyles}>{row.parameter}</TableCell>
        <TableCell sx={commonCellStyles}>{formatValue(row)}</TableCell>
        <TableCell sx={commonCellStyles}>{row.investor}</TableCell>
        <TableCell sx={commonCellStyles}>{formatDate({ date: row.date })}</TableCell>
        <TableCell sx={commonCellStyles}>
          <Chip
            sx={{ backgroundColor: "#F6F8FC" }}
            avatar={<Avatar src={row.entered_by.profile_photo_url} sx={{ width: 24, height: 24, mr: 1 }} />}
            label={row.entered_by.full_name}
          />
        </TableCell>
      </TableRow>
      {isOpen &&
        row?.children?.map((row, index, arr) => (
          <Row
            key={row.id || index}
            //  {...restProps}
            row={row}
            hideChildCell
            borderLess={index < arr.length - 1}
          />
        ))}
    </>
  );
};
